import React from 'react'

import './editAdmin.css'

const EditAdmin = () => {
  return (
    <div>EditAdmin</div>
  )
}

export default EditAdmin